"use client";

import { useSidebar } from "@/context/sidebar-context";

import SidebarMenu from "@/components/sidebar/content/sidebar-menu";
import classNames from "classnames";
import { HTMLProps, PropsWithChildren } from "react";
import SidebarAccount from "./sidebar/content/sidebar-account";

type MenuToggleProps = {
  type: "menu" | "account";
  isIcon?: boolean;
  className?: HTMLProps<HTMLElement>["className"];
  "aria-label"?: string;
} & PropsWithChildren;

const MenuToggle = (props: MenuToggleProps) => {
  const { isOpen, open, close } = useSidebar();

  const menuContent = () => {
    if (props.type === "account") {
      return <SidebarAccount />;
    }

    return <SidebarMenu />;
  };

  return (
    <button
      aria-expanded={isOpen}
      className={classNames(props.className, {
        "btn-icon": props.isIcon,
      })}
      aria-label={props["aria-label"]}
      onClick={() => (isOpen ? close() : open(menuContent()))}
    >
      {props.children}
    </button>
  );
};

export default MenuToggle;
